import { formatEt, relativeAge } from '../lib/time';

/** An ISO timestamp in ET with its age; a dash when there is none. */
export function Timestamp({ value }: { value: string | null }) {
  if (!value) {
    return <span className="sk:text-fg-tertiary">—</span>;
  }
  return (
    <time dateTime={value} className="sk:whitespace-nowrap">
      {formatEt(value)}{' '}
      <span className="sk:text-fg-tertiary">({relativeAge(value)})</span>
    </time>
  );
}
